import React from 'react';
import CustomTable from '../../../../../components/table/CustomTable';
import { VisitorTabTableApp } from '../Functionality/VisitorTabTableApp';
import { VISITOR_VIEWS_FROM } from '../../Guard/Model/Model';
import VisitorMainHeader from './VisitorMainHeader';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 */

const VisitorTabTable = (props) => {
    const {
        selectedList,
        setSelectedList,
        view, setView,
        searchElement, setSearchElement,
        setBodyForExport,
        finalArray,
        setFinalArray,
        search, setSearch,
        viewOrigin,
        getChildrenNotInformation,
        subView,
        handleSubViewChange,
        setSearchResults,
        setCriteria,
        setDeleteModal,
        goUpdate,
        modified,
        setModified,
        setShowRequestAccessModal,
        showSuccessMsgRef
    } = props;

    const {
        DEV,
        permission,
        setResults,
        option,
        rowsPerPage,
        setSimpleSearch,
        tableId,
        searchId,
        isAllChecked,
        thead,
        tbody,
        deletePermission,
        pagination,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        getData,
    } = VisitorTabTableApp({
        selectedList,
        setSelectedList,
        setCriteria,
        searchElement,
        finalArray,
        setSearch,
        setDeleteModal,
        goUpdate,
        modified,
        setModified,
        viewOrigin,
        setShowRequestAccessModal,
        showSuccessMsgRef
    });

    return (
        <>
            <VisitorMainHeader
                DEV={DEV}
                permission={permission}
                view={view}
                setView={setView}
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                setFinalArray={setFinalArray}
                setResults={setResults}
                getData={getData}
                viewOrigin={viewOrigin}
            />

            <div className={"mt-3"}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={deletePermission}
                    checkboxTitle={'de_/_select_all'}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                    thead={thead}
                    tbody={tbody}
                    columnActions={true}
                    getActionsButtons={getActionsButtons}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectedList}
                    childrenNotInformation={getChildrenNotInformation(VISITOR_VIEWS_FROM.VISITOR_GUARD)}
                />
                {pagination()}
            </div>
        </>
    );
};

export default VisitorTabTable;
